module.exports = __webpack_public_path__ + "img/lx-img1.768b6fbc.png";